import React, { Component } from 'react';

// Make sure to import default styles.
// This only needs to be done once; probably during bootstrapping process.


// Then import the virtualized Select HOC
import VirtualizedSelect from 'react-virtualized-select'

import { observable, computed } from 'mobx';
import { observer, inject } from 'mobx-react'
@inject("store")
@observer
class SpecialInterests extends Component {

	@observable error = false
	@observable errorText = "Please fill the name"

	state = {
		options: [],
		interestsValues: []
	}


	componentDidMount() {
		this.props.store.step = 3
		this.props.store.api.get('/guest/interests')
			.then(({ data }) => {
				const options = data.map(interest => {
					return { label: interest.title, value: interest.title }
				})
				this.setState({ options })
				this.setState({ interestsValues: [...this.props.store.doctor.interestsValues] })
			})
	}

	@computed get completed() {
		// const { doctor } = this.props.store
		// if (!(doctor.field.title)) { return false  }
		return true
	}

	handleNext = () => {
		if (!this.completed) { this.error = true;return  }
		this.props.store.nextStep()
		this.props.history.push(`/listing/new/${this.props.store.step + 2}`)
	}

	handlePrev = () => {
		this.props.store.prevStep()
		this.props.history.push(`/listing/new/${this.props.store.step}`)
	}

	handleInterest = (interestsValues) => {
		const { doctor } = this.props.store
		doctor.interestsValues = interestsValues
		this.setState({ interestsValues })
	}

	render() {
		const { doctor } = this.props.store
		return (
			<div>

				<h2>4. Special Interests</h2>

			
				<h4>
					Add your Special Interests
				</h4>	
				<p className="m-b-1">You can select more than one.</p>
				
				
				<VirtualizedSelect
					options={this.state.options}
					multi
					autoFocus
					placeholder="Search for special interest..."
					onChange={this.handleInterest}
					value={this.state.interestsValues}
				/>
				
				<hr />
				
				
				<h4>
					Special Interest(s) not listed?
				</h4>	
				
				
				{doctor.interests && doctor.interests.map((theInterest, index) =>
					<div key={index} className="m-b-1">
						<input
							className={`input medium m-r-1`}
							type="email"
							placeholder="Allergy..."
							value={theInterest.title} 
							onChange={e => { theInterest.title = e.target.value; }}
						/>
						<div className="btn base sm" onClick={()=>doctor.interests.splice(index,1)}><i className="fa fa-fw fa-times"></i> Remove</div>
					</div>)}
				
				<div>
					<div
						onClick={()=>doctor.interests.push({ title: ""})}
						className={`btn sm m-b-1`}><i className="fa fa-fw fa-plus"></i> Add new Special Interest</div>	
				</div>
				
				<hr/>

				<div className="m-t-1">
					<div
						onClick={this.handlePrev}	
						className={`btn base m-r-1`}><i className="fa fa-fw fa-arrow-left"></i> Previous</div>	
					<div
						onClick={this.handleNext}	
						className={`btn ${!this.completed && 'disabled'}`}><i className="fa fa-fw fa-arrow-right"></i> Next</div>
				</div>

				
				
			</div>
		);
	}
}

export default SpecialInterests;


// WEBPACK FOOTER //
// ./src/Containers/Listing/4.SpecialInterests.js